import React from "react";
import { Link } from "react-router-dom";

import INFO from "../../data/user";

import "./styles/logo.css";

const Logo = (props) => {
  let { width, link } = props;

  if (link === undefined) {
    link = true;
  }

  const imageElement = (
    <img
      src={require("../../assets/logo.png")}
      alt="Akash Dandriyal's logo"
      className="logo"
      width={width}
    />
  );

  return <>{link ? <Link to="/">{imageElement}</Link> : imageElement}</>;
};

export default Logo;
